import React from 'react';
import { useFormContext } from 'react-hook-form';
import { CapaQuotationServiceType } from '@generated/graphql';
import * as assets from '@assets';
import { CustomizedTypography } from '@components/Customized';
import FormInputLayout from '../Layout/FormInputLayout';
import RequestFormFileInput from './RequestFormFileInput';

const CircuitFabricationFileInput: React.FC<{
  filesRef?: React.MutableRefObject<any[]>;
}> = ({ filesRef }) => {
  const { errors } = useFormContext();

  return (
    <FormInputLayout
      label="거버파일 등록"
      required={true}
      description="(zip, rar, 최대 용량 5M)"
    >
      <RequestFormFileInput
        filesRef={filesRef}
        serviceType={CapaQuotationServiceType.Pcb}
        quantityLimit={10}
        sizeLimitMB={5}
        type="gerber"
        acceptFileFormats=".zip, .rar"
        error={errors?.pcb?.fabricationFiles?.message}
        icon={
          <img
            src={assets.PCBProduceFileInputIcon}
            width={56}
            height={56}
            alt="거버파일 업로드"
          />
        }
        title={
          <CustomizedTypography
            variant="subtitle1"
            fontWeight="500"
            color="textPrimary"
            gutterBottoms={30}
            align="center"
          >
            설계정보가 담겨있는 거버파일을 <br />
            끌어다 놓으세요.
          </CustomizedTypography>
        }
        onDragText={
          <CustomizedTypography
            variant={'h4'}
            fontWeight="500"
            color="textPrimary"
            align="center"
          >
            끌어다 놓으세요.
          </CustomizedTypography>
        }
        description={<></>}
      />
    </FormInputLayout>
  );
};

export default CircuitFabricationFileInput;
